// extracted by mini-css-extract-plugin
var _1 = "ConfirmationModal-modulecontent__Ek7HM";
var _2 = "ConfirmationModal-moduledescription__bs9Tm";
var _3 = "ConfirmationModal-modulenotifications__LgRej ConfirmationModalNotifications-moduleConfirmationModalNotifications__M8jlR";
export { _1 as "content", _2 as "description", _3 as "notifications" }
